module.exports = __webpack_public_path__ + "img/icon-step-1.38d81952.svg";